import styled from 'styled-components';

export const TrendsListWrapper = styled.div`
  grid-area: sidebar;
  overflow: auto;
  border-right: 1px solid
    ${({ theme }) => theme['border--interactive--default']};
`;
